import { PrimaryIconButton } from "components";
import PencilVector from "../../../assets/img/pencilVector.svg";

const PrimaryEditButton = ({ onClick, tooltipTitle, disabled, loading, ...rest }) => {
  return (
    <PrimaryIconButton
      icon={<img src={PencilVector} alt="update-icon" />}
      onClick={onClick}
      tooltipTitle={tooltipTitle}
      disabled={disabled}
      loading={loading}
      {...rest}
    />
  );
};

export default PrimaryEditButton;
